export var Variant = /*#__PURE__*/ function(Variant) {
    Variant["error"] = "error";
    Variant["success"] = "success";
    Variant["loading"] = "loading";
    return Variant;
}({});
export var LabelPosition = /*#__PURE__*/ function(LabelPosition) {
    LabelPosition["right"] = "right";
    LabelPosition["bottom"] = "bottom";
    LabelPosition["top_floating"] = "top_floating";
    LabelPosition["bottom_floating"] = "bottom_floating";
    return LabelPosition;
}({});
